import {
  DiseaseRiskV2CommonProps,
  RecommendationExistenceInfo,
  hasDiseaseRiskOption,
} from "../commons";
import {
  MedicalFacilityReportLayout,
  PrintablePageLayout,
} from "./medical_facility_report/commons";
import InsomniaRiskContent1 from "./medical_facility_report/InsomniaRiskContent1";
import InsomniaRiskContent2 from "./medical_facility_report/InsomniaRiskContent2";
import InsomniaRiskContent3 from "./medical_facility_report/InsomniaRiskContent3";
import InsomniaRiskContent4 from "./medical_facility_report/InsomniaRiskContent4";
import SASRiskContent1 from "./medical_facility_report/SASRiskContent1";
import SASRiskContent2 from "./medical_facility_report/SASRiskContent2";

/**
 * {@link MedicalFacilityReport} 用のプロパティ
 */
export interface MedicalFacilityReportProps extends DiseaseRiskV2CommonProps {
  /** {@link RecommendationExistenceInfo} */
  existence: RecommendationExistenceInfo;
}
/**
 * 医療機関用レポート
 *
 * @param param0 {@link MedicalFacilityReportProps}
 * @returns 医療機関用レポート
 */
export default function MedicalFacilityReport({
  data,
  existence,
}: MedicalFacilityReportProps) {
  // 疾患リスクのオプションが存在しない場合、または疾患リスクがない場合、レポートを表示しない。
  if (!hasDiseaseRiskOption(existence) || data.disease_risks == null)
    return <></>;

  const opt = existence.recommendation_option;
  let pageNumber = 1;

  return (
    <>
      {opt.SAS && (
        <>
          <MedicalFacilityReportLayout
            title="睡眠時無呼吸症候群リスク"
            subTitle="（1/2）"
            examinee={data.examinee}
            pageNumber={pageNumber++}
          >
            <SASRiskContent1
              examinee={data.examinee}
              odi3Result={data.odi_3_result}
              spO2Metrics={data.spo2_metrics}
            />
          </MedicalFacilityReportLayout>
          {data.disease_risks.SAS && (
            <MedicalFacilityReportLayout
              title="睡眠時無呼吸症候群リスク"
              subTitle="（2/2）"
              examinee={data.examinee}
              pageNumber={pageNumber++}
            >
              <SASRiskContent2
                diseaseInfo={data.disease_risks.SAS}
                answeredDate={data.primary_interview_answered_date}
              />
            </MedicalFacilityReportLayout>
          )}
        </>
      )}
      {opt.insomnia && (
        <>
          {data.disease_risks.insomnia && (
            <MedicalFacilityReportLayout
              title="不眠症リスク"
              subTitle="（1/4）"
              examinee={data.examinee}
              pageNumber={pageNumber++}
              contentsGap="16px"
            >
              <InsomniaRiskContent1
                diseaseInfo={data.disease_risks.insomnia}
                answeredDate={data.primary_interview_answered_date}
              />
            </MedicalFacilityReportLayout>
          )}
          <MedicalFacilityReportLayout
            title="不眠症リスク"
            subTitle="（2/4）"
            examinee={data.examinee}
            pageNumber={pageNumber++}
            contentsGap="16px"
          >
            <InsomniaRiskContent2
              averageMeasurementData={data.average_measurement_data}
              detailInfoArray={data.detail_info_list}
              measurementPeriodEnd={data.measurement_period.end}
              measurementPeriodStart={data.measurement_period.start}
            />
          </MedicalFacilityReportLayout>
          <MedicalFacilityReportLayout
            title="不眠症リスク"
            subTitle="（3/4）"
            examinee={data.examinee}
            pageNumber={pageNumber++}
          >
            <InsomniaRiskContent3
              detailInfoArray={data.detail_info_list}
              measurementPeriodEnd={data.measurement_period.end}
              measurementPeriodStart={data.measurement_period.start}
            />
          </MedicalFacilityReportLayout>
          <PrintablePageLayout
            title="不眠症リスク"
            subTitle="（4/4）"
            pageNumber={pageNumber++}
          >
            <InsomniaRiskContent4 />
          </PrintablePageLayout>
        </>
      )}
    </>
  );
}
